import React from 'react';
import { Accordion, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../styles/Faq.css';

const FAQs = () => {
  const navigate = useNavigate();

  const faqList = [
    {
      q: 'What services does Aligned Vertical offer?',
      a: 'We offer IT Infrastructure, Network Setup, Telecom Solutions, and Managed Support Services tailored for businesses.',
    },
    {
      q: 'How experienced is Aligned Vertical in this industry?',
      a: 'SEPL has 10+ years of experience delivering secure, scalable, and reliable solutions in the IT and telecom domain.',
    },
    {
      q: 'Do you provide 24/7 technical support?',
      a: 'Yes, our team is available round-the-clock to provide immediate support and ensure service continuity.',
    },
    {
      q: 'Can SEPL handle enterprise-level networking?',
      a: 'Absolutely! We specialize in high-performance, secure, and scalable enterprise networking solutions.',
    },
    {
      q: 'Is my data secure with Aligned Vertical?',
      a: 'We follow industry-leading security practices and compliance to ensure your data remains fully protected.',
    },
  ];

  return (
    <section className="faq-section py-5">
      <Container>
        <h2 className="text-center fw-bold mb-4 faq-title">Frequently Asked Questions</h2>

        <Accordion defaultActiveKey="0" flush>
          {faqList.map((item, index) => (
            <Accordion.Item eventKey={index.toString()} key={index} data-aos="fade-up">
              <Accordion.Header>{item.q}</Accordion.Header>
              <Accordion.Body>{item.a}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>

        {/* 🔽 Back button at bottom */}
        <div className="text-center mt-5">
          <Button variant="outline-dark" className="back-btn" onClick={() => navigate(-1)}>
            ← Back
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default FAQs;
